import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import CustomPopUp from '@/components/common/CustomPopUp';
import ForestMassPopupContent from '@/components/ForestMassList/ForestMassPopupContent';
import type {ForestMassStatus} from '@/domain/entities/ForestMassStatus';

//TYPES
type Props = {
  forestMassStatus: ForestMassStatus;
  onClick: (uuid: string) => void;
  onClose: () => void;
};

const ForestMassPopup: FC<Props> = ({forestMassStatus, onClick}) => {
  const {t} = useTranslation();
  const {forestMassUuid, position} = forestMassStatus;

  return (
    <CustomPopUp
      key={forestMassUuid}
      longitude={Number(position.coordinates[0])}
      latitude={Number(position.coordinates[1])}
      title={t('inventoryPlots.title')}
    >
      <ForestMassPopupContent forestMassStatus={forestMassStatus} onClick={onClick} />
    </CustomPopUp>
  );
};
export default ForestMassPopup;
